export default "__VITE_ASSET__nXCZve7d__"